// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"b50be79a","444":"8c2963a4","453":"670e15c7","494":"97763836"}[chunkId] + ".chunk.js";
};